export const sliderData = [
  {
    id: 1,
    sliderContent: "Finance",
    sliderImg: "slider-finance.svg",
  },
  {
    id: 2,
    sliderContent: "Banking",
    sliderImg: "slider-bank.svg",
  },
  {
    id: 3,
    sliderContent: "Insurance",
    sliderImg: "slider-insurance.svg",
  },
  {
    id: 4,
    sliderContent: "Legal",
    sliderImg: "slider-legal.svg",
  },
  {
    id: 5,
    sliderContent: "Education",
    sliderImg: "slider-edu.svg",
  },
  {
    id: 6,
    sliderContent: "Health",
    sliderImg: "slider-health.svg",
  },
  {
    id: 7,
    sliderContent: "Game",
    sliderImg: "slider-game.svg",
  },
  {
    id: 8,
    sliderContent: "Entertainment",
    sliderImg: "slider-entertain.svg",
  },
  {
    id: 9,
    sliderContent: "Events",
    sliderImg: "slider-events.svg",
  },
  {
    id: 10,
    sliderContent: "On Demand",
    sliderImg: "slider-demand.svg",
  },
  {
    id: 11,
    sliderContent: "Retail",
    sliderImg: "slider-retail.svg",
  },
  {
    id: 12,
    sliderContent: "Restaurant",
    sliderImg: "slider-restaurant.svg",
  },
  {
    id: 13,
    sliderContent: "Travel",
    sliderImg: "slider-travel.svg",
  },
  {
    id: 14,
    sliderContent: "Logistics",
    sliderImg: "slider-logistics.svg",
  },
  {
    id: 15,
    sliderContent: "Energy",
    sliderImg: "slider-energy.svg",
  },
  {
    id: 16,
    sliderContent: "Agriculture",
    sliderImg: "slider-agri.svg",
  },
  {
    id: 17,
    sliderContent: "Real Estate",
    sliderImg: "slider-realestate.svg",
  },
  {
    id: 18,
    sliderContent: "Construction",
    sliderImg: "slider-construction.svg",
  },
];

export const webSliderData = [
  {
    id: 1,
    sliderContent: "WEB3.0",
    sliderImg: "slider-webThree.svg",
  },
  { id: 2, sliderContent: "WEB2.0", sliderImg: "slider-webTwo.svg" },
  {
    id: 3,
    sliderContent: "AI & ML",
    sliderImg: "slider-ai.svg",
  },
  {
    id: 4,
    sliderContent: "Construction",
    sliderImg: "slider-construction.svg",
  },
  {
    id: 5,
    sliderContent: "Blockchain",
    sliderImg: "slider-block.svg",
  },
  {
    id: 6,
    sliderContent: "Banking",
    sliderImg: "slider-bank.svg",
  },
  {
    id: 7,
    sliderContent: "Insurance",
    sliderImg: "slider-insurance.svg",
  },
  {
    id: 8,
    sliderContent: "Legal",
    sliderImg: "slider-legal.svg",
  },
  {
    id: 9,
    sliderContent: "Education",
    sliderImg: "slider-edu.svg",
  },
  {
    id: 10,
    sliderContent: "Health",
    sliderImg: "slider-health.svg",
  },
  {
    id: 11,
    sliderContent: "Game",
    sliderImg: "slider-game.svg",
  },
  {
    id: 12,
    sliderContent: "Entertainment",
    sliderImg: "slider-entertain.svg",
  },
  {
    id: 13,
    sliderContent: "Events",
    sliderImg: "slider-events.svg",
  },
  {
    id: 14,
    sliderContent: "On Demand",
    sliderImg: "slider-demand.svg",
  },
  {
    id: 15,
    sliderContent: "Retail",
    sliderImg: "slider-retail.svg",
  },
  {
    id: 16,
    sliderContent: "Restaurant",
    sliderImg: "slider-restaurant.svg",
  },
  {
    id: 17,
    sliderContent: "Travel",
    sliderImg: "slider-travel.svg",
  },
  {
    id: 18,
    sliderContent: "Logistics",
    sliderImg: "slider-logistics.svg",
  },
];

export const exploreData = [
  {
    id: 1,
    serviceName: "service 01",
    cardTitle: "Blockchain Service",
    cardImg: "cardImgThree.webp",
    cardContent:
      "Build secure and scalable blockchain solutions to transform your business processes. Unlock innovation with decentralized technology and smart contracts.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Crypto Exchange",
        subContent:
          "Build a secure and scalable cryptocurrency exchange tailored to your needs.",
        subHeadImg: "cardIcon.png",
      },
      {
        subHead: "Trading Bot",
        subContent: "Automate your trades with advanced crypto trading bots.",
        subHeadImg: "trading-bot.svg",
      },
      {
        subHead: "Defi",
        subContent:
          "Unlock decentralized finance opportunities for transparent and open finance.",
        subHeadImg: "nft.svg",
      },
      {
        subHead: "Crypto Token",
        subContent:
          "Launch custom crypto tokens to power your digital economy.",
        subHeadImg: "crypto-token.svg",
      },
      {
        subHead: "NFT",
        subContent:
          "Create, trade, and manage unique digital assets with NFT solutions.",
        subHeadImg: "nft.svg",
      },
      {
        subHead: "Crypto Payment",
        subContent:
          "Enable seamless and secure cryptocurrency payments for your business.",
        subHeadImg: "crypto-payment.svg",
      },
    ],
  },
  {
    id: 2,
    serviceName: "service 02",
    cardTitle: "AI/ML Solution",
    cardImg: "ai-ml.webp",
    cardContent:
      "AI and machine learning to automate tasks and help intelligent decision making. Achieve smarter business outcomes with AI powered solutions.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "AI Development Company",
        subContent: "Partner with experts in advanced AI development services.",
        subHeadImg: "ai-development.svg",
      },
      {
        subHead: "Generative AI Development",
        subContent:
          "Create innovative AI solutions that generate new content and ideas.",
        subHeadImg: "generative-ai.svg",
      },
      {
        subHead: "AI/ML Development",
        subContent:
          "Utilise AI/ML technologies to maximise business growth and progress.",
        subHeadImg: "ai-ml-develop.svg",
      },
      {
        subHead: "AI Chat  Development",
        subContent:
          "Develop AI powered chatbot solutions for efficient customer engagement.",
        subHeadImg: "ai-chat.svg",
      },
    ],
  },
  {
    id: 3,
    serviceName: "service 03",
    cardTitle: "Software Development",
    cardImg: "software.webp",
    cardContent:
      "Develop custom software tailored to your unique needs with advanced technology. Streamline operations and enhance performance with agile development services.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Nearshore Software",
        subContent:
          "Streamline software development with our cost-effective nearshore services.",
        subHeadImg: "nearshore-software.svg",
      },
      {
        subHead: "Custom Software",
        subContent:
          "Get advanced software that perfectly fits your business requirements.",
        subHeadImg: "custom-software.svg",
      },
      {
        subHead: "CRM Development",
        subContent: "Enhance customer relationships with custom CRM software.",
        subHeadImg: "crm.svg",
      },
      {
        subHead: "Agile Software",
        subContent:
          "Build flexible, agile software solutions that evolve with your business needs.",
        subHeadImg: "agile-software.svg",
      },
      {
        subHead: "Offshore Development",
        subContent:
          "Outsource your development needs to our experienced offshore teams.",
        subHeadImg: "offshore-development.svg",
      },
      {
        subHead: "ERP Software",
        subContent:
          "Manage and automate your business operations with powerful ERP software.",
        subHeadImg: "erp-software.svg",
      },
    ],
  },
  {
    id: 4,
    serviceName: "service 04",
    cardTitle: "Mobile & Web Development",
    cardImg: "mobile.webp",
    cardContent:
      "Create high performance mobile and web applications to engage users and expand your digital presence. Deliver seamless experiences across all devices.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "IOS App Development",
        subContent:
          "Build high-performance iOS apps for an exceptional user experience.",
        subHeadImg: "ios-app.svg",
      },
      {
        subHead: "Progressive App",
        subContent:
          "Develop fast, reliable, and engaging progressive web apps.",
        subHeadImg: "progressive-app.svg",
      },
      {
        subHead: "Android App Development",
        subContent: "Create feature-rich android apps for a global audience.",
        subHeadImg: "android-app.svg",
      },
      {
        subHead: "Web App Development",
        subContent: "Build responsive, secure, and scalable web applications.",
        subHeadImg: "web-app.svg",
      },
    ],
  },
  {
    id: 5,
    serviceName: "service 05",
    cardTitle: "Digital Marketing",
    cardImg: "digital-marketing.webp",
    cardContent:
      "Boost your brand visibility and reach your target audience with expert digital marketing strategies. Achieve progress with SEO, social media and content marketing.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Branding",
        subContent:
          "Strengthen your brand identity with innovative marketing strategies.",
        subHeadImg: "branding.svg",
      },
      {
        subHead: "Content Marketing",
        subContent:
          "Drive engagement and traffic with strategic content marketing.",
        subHeadImg: "content-marketing.svg",
      },
      {
        subHead: "SEO & SMM",
        subContent:
          "Boost your online visibility with expert SEO and social media marketing.",
        subHeadImg: "seo.svg",
      },
      {
        subHead: "ICO Marketing",
        subContent:
          "Launch your crypto project successfully with targeted ICO marketing.",
        subHeadImg: "ico.svg",
      },
    ],
  },
  {
    id: 6,
    serviceName: "service 06",
    cardTitle: "FOREX Trading",
    cardImg: "forex-trading.webp",
    cardContent:
      "Build advanced FOREX trading platforms and tools to empower traders with automated solutions. Stay ahead in the market with reliable trading software.",
    cardBtn: "Explore",
    cardLink: "/contact-us",
    cardSubContents: [
      {
        subHead: "Custom Trading Platform",
        subContent:
          "Build a custom trading platform that meets your unique FOREX trading needs.",
        subHeadImg: "custom-trading.svg",
      },
      {
        subHead: `MT4 & MT5 Trading Software`,
        subContent:
          "Develop robust MT4 & MT5 trading platforms for enhanced performance.",
        subHeadImg: "mt.svg",
      },
      {
        subHead: "Forex Algorithm Trading Bot",
        subContent:
          "Optimize trades with smart, automated algorithmic trading bots.",
        subHeadImg: "forex-algorithm.svg",
      },
      {
        subHead: "Forex Trading App Development",
        subContent:
          "Design and launch an advanced FOREX trading app for traders on the go.",
        subHeadImg: "forex-trading-app.svg",
      },
    ],
  },
];

export const industryCardData = [
  {
    id: 1,
    industryCardTitle: "Game Industry",
    industryCardContent:
      "Build immersive gaming experiences using blockchain technology.",
    industryCardImg: "game.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 2,
    industryCardTitle: "Entertainment Industry",
    industryCardContent:
      "Explore new ways to engage audiences with blockchain in entertainment.",
    industryCardImg: "entertainment.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 3,
    industryCardTitle: "Event Industry",
    industryCardContent:
      "Manage events more efficiently with blockchain-powered ticketing and management.",
    industryCardImg: "event.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 4,
    industryCardTitle: "On Demand Industry",
    industryCardContent:
      "Streamline operations for on-demand services using blockchain solutions.",
    industryCardImg: "on-demand.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 5,
    industryCardTitle: "Finance Industry",
    industryCardContent:
      "Drive growth with blockchain solutions developed for financial institutions.",
    industryCardImg: "finance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 6,
    industryCardTitle: "Banking Industry",
    industryCardContent:
      "Innovate in the banking sector with secure and scalable blockchain technology.",
    industryCardImg: "banking.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 7,
    industryCardTitle: "Insurance Industry",
    industryCardContent:
      "Automate and secure insurance processes with blockchain driven solutions.",
    industryCardImg: "insurance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 8,
    industryCardTitle: "Legal Industry",
    industryCardContent:
      "Simplify legal processes and enhance trust with blockchain for the legal industry.",
    industryCardImg: "legal.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 9,
    industryCardTitle: "Education Industry",
    industryCardContent:
      "Change learning with blockchain solutions for education.",
    industryCardImg: "education.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 10,
    industryCardTitle: "Health Industry",
    industryCardContent:
      "Improve healthcare services with secure and transparent blockchain applications.",
    industryCardImg: "health.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 11,
    industryCardTitle: "Retail & E-Commerce",
    industryCardContent:
      "Enhance trust and efficiency in retail with blockchain for supply chain.",
    industryCardImg: "retail.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 12,
    industryCardTitle: "Restaurant",
    industryCardContent:
      "Boost operational efficiency and customer engagement with blockchain for restaurants.",
    industryCardImg: "restaurant.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 13,
    industryCardTitle: "Travel Industry",
    industryCardContent:
      "Simplify travel services with secure and decentralized blockchain platforms.",
    industryCardImg: "travel.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 14,
    industryCardTitle: "Logistics Industry",
    industryCardContent:
      "Optimize supply chain and logistics operations with blockchain technology.",
    industryCardImg: "logistics.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 15,
    industryCardTitle: "Energy Industry",
    industryCardContent:
      "Improve transparency and sustainability with blockchain in the energy sector.",
    industryCardImg: "energy.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 16,
    industryCardTitle: "Agriculture",
    industryCardContent:
      "Modernize farming practices with blockchain solutions for agriculture.",
    industryCardImg: "agri.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 17,
    industryCardTitle: "Real Estates",
    industryCardContent:
      "Simplify property transactions with blockchain for real estate.",
    industryCardImg: "real-estate.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 18,
    industryCardTitle: "Construction",
    industryCardContent:
      "Improvise project management with blockchain for construction with transparent solutions.",
    industryCardImg: "construction.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 19,
    industryCardTitle: "Game Industry",
    industryCardContent:
      "Build immersive gaming experiences using blockchain technology.",
    industryCardImg: "game.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 20,
    industryCardTitle: "Entertainment Industry",
    industryCardContent:
      "Explore new ways to engage audiences with blockchain in entertainment.",
    industryCardImg: "entertainment.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 21,
    industryCardTitle: "Event Industry",
    industryCardContent:
      "Manage events more efficiently with blockchain-powered ticketing and management.",
    industryCardImg: "event.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 22,
    industryCardTitle: "On Demand Industry",
    industryCardContent:
      "Streamline operations for on-demand services using blockchain solutions.",
    industryCardImg: "on-demand.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 23,
    industryCardTitle: "Finance Industry",
    industryCardContent:
      "Drive growth with blockchain solutions developed for financial institutions.",
    industryCardImg: "finance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 24,
    industryCardTitle: "Banking Industry",
    industryCardContent:
      "Innovate in the banking sector with secure and scalable blockchain technology.",
    industryCardImg: "banking.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 25,
    industryCardTitle: "Insurance Industry",
    industryCardContent:
      "Automate and secure insurance processes with blockchain driven solutions.",
    industryCardImg: "insurance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 26,
    industryCardTitle: "Legal Industry",
    industryCardContent:
      "Simplify legal processes and enhance trust with blockchain for the legal industry.",
    industryCardImg: "legal.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 27,
    industryCardTitle: "Education Industry",
    industryCardContent:
      "Change learning with blockchain solutions for education.",
    industryCardImg: "education.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 28,
    industryCardTitle: "Health Industry",
    industryCardContent:
      "Improve healthcare services with secure and transparent blockchain applications.",
    industryCardImg: "health.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 29,
    industryCardTitle: "Retail & E-Commerce",
    industryCardContent:
      "Enhance trust and efficiency in retail with blockchain for supply chain.",
    industryCardImg: "retail.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 30,
    industryCardTitle: "Restaurant",
    industryCardContent:
      "Boost operational efficiency and customer engagement with blockchain for restaurants.",
    industryCardImg: "restaurant.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 31,
    industryCardTitle: "Travel Industry",
    industryCardContent:
      "Simplify travel services with secure and decentralized blockchain platforms.",
    industryCardImg: "travel.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 32,
    industryCardTitle: "Logistics Industry",
    industryCardContent:
      "Optimize supply chain and logistics operations with blockchain technology.",
    industryCardImg: "logistics.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 33,
    industryCardTitle: "Energy Industry",
    industryCardContent:
      "Improve transparency and sustainability with blockchain in the energy sector.",
    industryCardImg: "energy.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 34,
    industryCardTitle: "Agriculture",
    industryCardContent:
      "Modernize farming practices with blockchain solutions for agriculture.",
    industryCardImg: "agri.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 35,
    industryCardTitle: "Real Estates",
    industryCardContent:
      "Simplify property transactions with blockchain for real estate.",
    industryCardImg: "real-estate.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 36,
    industryCardTitle: "Construction",
    industryCardContent:
      "Improvise project management with blockchain for construction with transparent solutions.",
    industryCardImg: "construction.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 37,
    industryCardTitle: "Game Industry",
    industryCardContent:
      "Build immersive gaming experiences using blockchain technology.",
    industryCardImg: "game.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 38,
    industryCardTitle: "Entertainment Industry",
    industryCardContent:
      "Explore new ways to engage audiences with blockchain in entertainment.",
    industryCardImg: "entertainment.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 39,
    industryCardTitle: "Event Industry",
    industryCardContent:
      "Manage events more efficiently with blockchain-powered ticketing and management.",
    industryCardImg: "event.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 40,
    industryCardTitle: "On Demand Industry",
    industryCardContent:
      "Streamline operations for on-demand services using blockchain solutions.",
    industryCardImg: "on-demand.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 41,
    industryCardTitle: "Finance Industry",
    industryCardContent:
      "Drive growth with blockchain solutions developed for financial institutions.",
    industryCardImg: "finance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 42,
    industryCardTitle: "Banking Industry",
    industryCardContent:
      "Innovate in the banking sector with secure and scalable blockchain technology.",
    industryCardImg: "banking.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 43,
    industryCardTitle: "Insurance Industry",
    industryCardContent:
      "Automate and secure insurance processes with blockchain driven solutions.",
    industryCardImg: "insurance.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 44,
    industryCardTitle: "Legal Industry",
    industryCardContent:
      "Simplify legal processes and enhance trust with blockchain for the legal industry.",
    industryCardImg: "legal.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 45,
    industryCardTitle: "Education Industry",
    industryCardContent:
      "Change learning with blockchain solutions for education.",
    industryCardImg: "education.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 46,
    industryCardTitle: "Health Industry",
    industryCardContent:
      "Improve healthcare services with secure and transparent blockchain applications.",
    industryCardImg: "health.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 47,
    industryCardTitle: "Retail & E-Commerce",
    industryCardContent:
      "Enhance trust and efficiency in retail with blockchain for supply chain.",
    industryCardImg: "retail.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 48,
    industryCardTitle: "Restaurant",
    industryCardContent:
      "Boost operational efficiency and customer engagement with blockchain for restaurants.",
    industryCardImg: "restaurant.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 49,
    industryCardTitle: "Travel Industry",
    industryCardContent:
      "Simplify travel services with secure and decentralized blockchain platforms.",
    industryCardImg: "travel.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 50,
    industryCardTitle: "Logistics Industry",
    industryCardContent:
      "Optimize supply chain and logistics operations with blockchain technology.",
    industryCardImg: "logistics.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 51,
    industryCardTitle: "Energy Industry",
    industryCardContent:
      "Improve transparency and sustainability with blockchain in the energy sector.",
    industryCardImg: "energy.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 52,
    industryCardTitle: "Agriculture",
    industryCardContent:
      "Modernize farming practices with blockchain solutions for agriculture.",
    industryCardImg: "agri.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 53,
    industryCardTitle: "Real Estates",
    industryCardContent:
      "Simplify property transactions with blockchain for real estate.",
    industryCardImg: "real-estate.webp",
    industryCardLink: "/contact-us",
  },
  {
    id: 54,
    industryCardTitle: "Construction",
    industryCardContent:
      "Improvise project management with blockchain for construction with transparent solutions.",
    industryCardImg: "construction.webp",
    industryCardLink: "/contact-us",
  },
];

export const blockchainImgData = [
  {
    id: 1,
    blockchainImg: "bitcoin.webp",
    blockchainName: "Bitcoin",
  },
  {
    id: 2,
    blockchainImg: "eth.webp",
    blockchainName: "Ethereum",
  },
  {
    id: 3,
    blockchainImg: "solana.webp",
    blockchainName: "Solana",
  },
  {
    id: 4,
    blockchainImg: "binance.webp",
    blockchainName: "Binance",
  },
  {
    id: 5,
    blockchainImg: "polygon.webp",
    blockchainName: "Polygon",
  },
  {
    id: 6,
    blockchainImg: "ripple.webp",
    blockchainName: "Ripple",
  },
  {
    id: 7,
    blockchainImg: "tron.webp",
    blockchainName: "Tron",
  },
  {
    id: 8,
    blockchainImg: "cardano.webp",
    blockchainName: "Cardano",
  },
  {
    id: 9,
    blockchainImg: "avalanche.webp",
    blockchainName: "Avalanche",
  },
  {
    id: 10,
    blockchainImg: "polkadot.webp",
    blockchainName: "Polkadot",
  },
  {
    id: 11,
    blockchainImg: "near.webp",
    blockchainName: "Near",
  },
  {
    id: 12,
    blockchainImg: "aptos.webp",
    blockchainName: "Aptos",
  },
  {
    id: 13,
    blockchainImg: "stellar.webp",
    blockchainName: "Stellar",
  },
  {
    id: 14,
    blockchainImg: "arbitrum.webp",
    blockchainName: "Arbitrum",
  },
  {
    id: 15,
    blockchainImg: "cosmos.webp",
    blockchainName: "Cosmos",
  },
];

export const frontendImages = [
  { techImg: "html.svg", alt: "HTML" },
  { techImg: "vue.svg", alt: "Vue" },
  { techImg: "nuxt.svg", alt: "Nuxt" },
  { techImg: "css.svg", alt: "CSS" },
  { techImg: "svelte.svg", alt: "Svelte" },
  { techImg: "next.svg", alt: "Next" },
  { techImg: "react.svg", alt: "React" },
  { techImg: "angular.svg", alt: "Angular" },
];

export const featureCardData = [
  {
    id: 1,
    cardTitle: "User-Friendly interface",
    cardContent:
      " The success of any ride-hailing service lies in its simplicity. An Uber clone app offers an intuitive, easy-to-navigate interface that enables users to book rides with just a few taps. The seamless design ensures a smooth user experience, from signup to ride completion.",
    icon: "user-friendly.webp",
  },
  {
    id: 2,
    cardTitle: "Real-Time tracking",
    cardContent:
      "One of the standout features of an Uber clone is real-time GPS tracking. Both drivers and passengers can view each other’s locations, making ride coordination simple and efficient. This also ensures security and transparency.",
    icon: "real-time.webp",
  },
  {
    id: 3,
    cardTitle: "Multiple payment options",
    cardContent:
      " An Uber clone app integrates various payment gateways, allowing users to pay using credit cards, debit cards, digital wallets, or even cash. The secure payment process ensures that users feel safe when using your app.",
    icon: "multiple.webp",
  },
  {
    id: 4,
    cardTitle: "Driver and passenger profiles",
    cardContent:
      "The Uber clone provides separate dashboards for drivers and passengers. Users can set up profiles, manage personal information, and review their ride history. Drivers can also track their earnings.",
    icon: "driver.webp",
  },
  {
    id: 5,
    cardTitle: "In-App communication",
    cardContent:
      "Efficient communication between drivers and passengers is critical. The Uber clone app includes in-app messaging and calling features that make it easier for both parties to stay connected before and during the ride.",
    icon: "communication.webp",
  },
  {
    id: 6,
    cardTitle: "Ride scheduling",
    cardContent:
      "Your Uber clone can include a ride-scheduling feature that allows users to book rides in advance. This is particularly useful for airport transfers or early morning commutes.",
    icon: "ride.webp",
  },
  {
    id: 7,
    cardTitle: "Fare estimation",
    cardContent:
      "With a built-in fare estimation feature, the Uber clone app provides users with the estimated cost of their trip before they book. This enhances transparency and helps passengers make informed decisions.",
    icon: "fare.webp",
  },
  {
    id: 8,
    cardTitle: "Ratings and reviews",
    cardContent:
      " Your Uber clone can include a ride-scheduling feature that allows users to book rides in advance. This is particularly useful for airport transfers or early morning commutes.",
    icon: "ratings.webp",
  },
];

export const openRoleData = [
  {
    id: 1,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 2,
    department: "Development",
    role: "Full Stack Developer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 3,
    department: "Development",
    role: "Smart contract developer",
    durationTitle: "Experience",
    duration: "6+ months | Paid",
    type: "Full Time",
    time: "9:30 am - 7:00 pm",
    months: "6 months ago",
  },
  {
    id: 4,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 5,
    department: "Development",
    role: "Full Stack Developer",
    durationTitle: "Experience",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
  {
    id: 6,
    department: "Designing",
    role: "UI/UX Designer",
    durationTitle: "Duration",
    duration: "3+ months | Paid",
    type: "Internship",
    time: "11:30 am - 5:00 pm",
    months: "4 months ago",
  },
];
